import { render, staticRenderFns } from "./DeviceDataPowerPage.vue?vue&type=template&id=90bb04ca&"
import script from "./DeviceDataPowerPage.vue?vue&type=script&lang=js&"
export * from "./DeviceDataPowerPage.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDataPowerPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports